import moment from 'moment';

import type { IntegrationDataType } from '@pages/IntegrationParsing/types';

export const getInfoItems = (data: IntegrationDataType) => [
  {
    id: 1,
    label: 'ID',
    value: data?.SocialIntegrationId ?? '-',
  },
  {
    id: 2,
    label: 'Название',
    value: data?.SocialIntegrationName ?? '-',
  },
  {
    id: 3,
    label: 'Тип',
    value: 'Email',
  },
  {
    id: 4,
    label: 'Дата создания',
    value: moment(data?.TimeCreated).format('DD.MM.YYYY HH:mm'),
  },
];
